import React from 'react';
import HeaderWrapper from '../components/common/HeaderWrapper';
import '../components/common/HowItWorks.css';
import './HowItWorksPage.css';

const HowItWorksPage = () => {

  return (
    <div className="home-container body-font">
      <HeaderWrapper />
      <div className="main-background home-main-background">
        <div className="content-wrapper home-content-wrapper">
          <main style={{ flex: '0 1 auto' }}>
            <div className="how-it-works-page">
              <div className="page-title-section">
                <h1 className="heading-font">How it works</h1>
              </div>

              {/* Browse content anytime section */}
              <div className="browse-section">
                <div className="browse-content">
                  <p className="browse-content-title">Browse free content anytime</p>
                  <p className="account-section">
                  <span className="account-link">Open an account</span> either as a <span className="user-type">USER</span><br></br>
                  (if you want to access paywalled content)<br></br>
                  or as a <span className="user-type">CREATIVE</span> (if you want your own page)
                  </p>
                  <p className="account-section"><span className="account-link">USERS</span> buy credits and spend them on content
                    &nbsp;<span className="account-link">CREATIVES</span> apply to set up their own page</p>
                </div>
                <div className="browse-image-container">
                <img src={require('../assets/store.png')} alt="Store" className="browse-image" />
                </div>
              </div>

              {/* Users section */}
              <div className="users-section">
                <div className="users-content">
                  <p className="account-section">
                      <span className="account-link">USERS</span>&nbsp;
                      50% of whatever you spend goes directly to the artist. All prices are set by the creative from 1
                      credit (10p) to 100 credits (£10)
                  </p>
                </div>
                <div className="users-image-container">
                  <img src={require('../assets/coin.png')} alt="Coins" className="users-image" />
                </div>
              </div>

              {/* Creatives section */}
              <div className="creatives-section">
                <div className="creatives-image-container">
                  <img src={require('../assets/coins.png')} alt="Coins" className="creatives-image" />
                </div>
                <div className="creatives-content">
                  <p className="account-section"><span className="account-link">CREATIVES</span>&nbsp;
                      If your application is approved you can upload content to your page and either offer it for free
                      access or set a price in 1 credit (10p) increments. You'll get half of whatever is spent on your content.
                  </p>
                </div>
              </div>

              <div className="terms-sections">
                <p className="terms-text">Access full Terms & Conditions <a href="/terms-and-conditions" className="terms-link">HERE</a></p>
              </div>
              
              {/*
              <div className="how-it-works-page-content">
                <div className="how-it-works-panel readers-panel">
                  <h2>{howItWorksConfig.readers.heading}</h2>
                  <div className="panel-description">
                    {howItWorksConfig.readers.description.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                  <div className="panel-buttons">
                    <button 
                      className="buy-credits-button" 
                      onClick={() => navigate('/credits')}
                    >
                      {howItWorksConfig.readers.buttons.buyCredits.text}
                      {howItWorksConfig.readers.buttons.buyCredits.icon && (
                        <img 
                          src={require('../assets/credit-icon.svg').default} 
                          alt="Credit Icon" 
                          className="button-icon" 
                        />
                      )}
                    </button>
                    <button 
                      className="browse-button" 
                      onClick={() => navigate('/')}
                    >
                      {howItWorksConfig.readers.buttons.browse.text}
                    </button>
                  </div>
                </div>
                
                <div className="how-it-works-panel creatives-panel">
                  <h2 className="creatives-heading">{howItWorksConfig.creatives.heading}</h2>
                  <div className="panel-description creatives-text">
                    {howItWorksConfig.creatives.description.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                  <div className="panel-buttons">
                    <button className="apply-button" onClick={() => window.location.href = '/manage-content'}>
                      {applyButtonText}
                    </button>
                  </div>
                </div>
              </div>
              */}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksPage;
